import * as React from "react";

function BestDealGraphicsIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 134 28"
    >
      <defs>
        <clipPath>
          <rect width="134" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-best-deal-graphics)">
        <path
          data-name="Path 7077"
          d="M-54.982,0h-7.176V-15.834h7.691q2.911.043,4.125,1.687a4.013,4.013,0,0,1,.73,2.417,3.534,3.534,0,0,1-.73,2.331,3.77,3.77,0,0,1-1.2.9,3.53,3.53,0,0,1,1.832,1.4A4.185,4.185,0,0,1-49.1-4.78,4.611,4.611,0,0,1-49.8-2.256,4.375,4.375,0,0,1-50.932-1.01a4.4,4.4,0,0,1-1.8.795A11.092,11.092,0,0,1-54.982,0Zm-.075-6.972H-59V-2.75h3.889a3.817,3.817,0,0,0,1.622-.279,1.989,1.989,0,0,0,1.053-1.977,1.7,1.7,0,0,0-1.021-1.7A4.089,4.089,0,0,0-55.057-6.972Zm1.644-3.019a1.481,1.481,0,0,0,.645-1.386,1.416,1.416,0,0,0-.859-1.461,6.082,6.082,0,0,0-1.891-.247H-59v3.491h3.889A3.236,3.236,0,0,0-53.414-9.99Zm18.551,3.072h-7.691v4.071h8.766V0h-12V-15.834h11.612v2.8h-8.379v3.362h7.691Zm9.839,4.63a5.826,5.826,0,0,0,1.9-.258,1.837,1.837,0,0,0,1.386-1.837A1.355,1.355,0,0,0-22.423-5.6a7.393,7.393,0,0,0-2.159-.741l-1.676-.376a10.59,10.59,0,0,1-3.416-1.214,3.861,3.861,0,0,1-1.6-3.427,4.576,4.576,0,0,1,1.547-3.534A6.54,6.54,0,0,1-25.184-16.3a6.909,6.909,0,0,1,4.27,1.327,4.737,4.737,0,0,1,1.853,3.851h-3.18a2.271,2.271,0,0,0-1.246-2.03,4.179,4.179,0,0,0-1.923-.4,3.59,3.59,0,0,0-2.041.516,1.642,1.642,0,0,0-.763,1.439,1.362,1.362,0,0,0,.752,1.268,9.2,9.2,0,0,0,2.063.655l2.729.655a7.054,7.054,0,0,1,2.707,1.149A3.871,3.871,0,0,1-18.546-4.63a4.563,4.563,0,0,1-1.66,3.6A6.953,6.953,0,0,1-24.894.408,7.606,7.606,0,0,1-29.76-1a4.694,4.694,0,0,1-1.772-3.883h3.158a3.251,3.251,0,0,0,.591,1.622A3.4,3.4,0,0,0-25.023-2.288ZM-4.151-15.834v2.8H-8.889V0h-3.33V-13.03h-4.759v-2.8ZM11.177,0H4.356V-15.834h6.821a8.322,8.322,0,0,1,2.449.344,5.227,5.227,0,0,1,2.7,2.009,7.046,7.046,0,0,1,1.128,2.557,12.273,12.273,0,0,1,.3,2.621,10.524,10.524,0,0,1-1.268,5.35A5.719,5.719,0,0,1,11.177,0Zm2.46-11.795q-.763-1.289-3.019-1.289H7.567V-2.75h3.051a3.3,3.3,0,0,0,3.266-2.31,8.146,8.146,0,0,0,.5-3.019A7.508,7.508,0,0,0,13.637-11.795ZM31.7-6.918H24.013v4.071h8.766V0h-12V-15.834H32.392v2.8H24.013v3.362H31.7ZM45.068-3.255H39.235L38.139,0H34.68l5.65-15.834h3.738L49.676,0H46.088Zm-.924-2.729-1.977-6.23-2.041,6.23Zm7.981-9.851h3.309V-2.847h7.842V0H52.125Z"
          transform="translate(67 23)"
          fill="#377cb7"
        />
      </g>
    </svg>
  );
}

export default BestDealGraphicsIcon;
